import { Map as ImmutableMap } from 'immutable';
import invariant from 'react-utils/invariant';
export const capabilityKeyInvariant = maybeCapabilityKey => invariant(ImmutableMap.isMap(maybeCapabilityKey) && maybeCapabilityKey.get('capability'), 'Capability key must be an immutable Map with a `capability` key');